// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"d151888f960e2a87e9ae","966":"908f55297e6fed608f53"}[chunkId] + ".js";
};